import TextField from "@/components/ui/Textfield";
import { JSX } from "react";
import { useAdCategoryStore } from "../store/adCategoryStore";
import { useShallow } from "zustand/react/shallow";

export default function CreateAdCategoriesStepOne(): JSX.Element {
  const { adCategory, setAdCategory } = useAdCategoryStore(
    useShallow((state) => ({
      adCategory: state.adCategory,
      setAdCategory: state.setAdCategory,
    })),
  );

  return (
    <div className="mt-6">
      <div className="font-bold text-xl mb-6">
        Assign a name to the Ad Category
      </div>
      <hr className="border-[#EA33C0] mb-6" />
      <div>
        <div className="text-gray-500 text-sm mb-1">Ad Category</div>
        <TextField
          type="text"
          placeholder="Ad Category Name"
          className="w-2/3"
          value={adCategory}
          onChange={(e) => setAdCategory(e.target.value)}
        />
      </div>
    </div>
  );
}
